import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ConstatService} from "../../services/constat.service";
import {IndexedDbService} from "../../services/indexed-db.service";
import {FullConstat} from "../../shared/interfaces/FullConstat";
import {Residency} from "../../shared/interfaces/Residency";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FileService} from "../../services/file.service";
import {SpinnerComponent} from "../../shared/components/spinner/spinner.component";
import {RouterLink} from "@angular/router";
import {UpperCasePipe} from "@angular/common";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  encapsulation: ViewEncapsulation.None,
  imports: [
    SpinnerComponent,
    RouterLink,
    UpperCasePipe
  ],
  standalone: true
})
export class HomeComponent implements OnInit {
  residency: Residency | undefined;
  residencyConstats: any[] = []
  dataStoredInIndexedDb: boolean = false;

  constructor(private constatService: ConstatService,
              private dexieDBService: IndexedDbService,
              private snackBar: MatSnackBar,
              private fileService: FileService) {
  }

  ngOnInit(): void {
    this.dexieDBService.getDatasFromIndexDb("selectedResidency", "selectedResidency",).then(async residences => {
      this.residency = residences?.residences[0];
      this.residencyConstats = residences?.constats ?? [];
      await this.getAllConstats()
      await this.getFileByConstatId()
      this.dataStoredInIndexedDb = true
    })
  }

  getAllConstats(): Promise<Awaited<unknown>[]> {
    const constatPromises = this.residencyConstats?.map((constat: any) => {
      return new Promise<void>((resolve) => {
        // Enregistrement des objets globaux constat en index db
        this.dexieDBService.constats.add(constat);

        // Récupération des sous-objets constat depuis l'API
        this.constatService.getConstatById(constat.id).subscribe(
          (fullConstat: FullConstat) => {
            // Enregistrement de ces objets dans index db si l'objet n'est pas déjà en cours de modif
            //TODO a tester en conditions réelles
            this.dexieDBService.getDatasFromIndexDb('inventoryInProgress', fullConstat.id).then(inventoryInProgress => {
              if (!inventoryInProgress) {
                this.dexieDBService.fullConstats.add(fullConstat);
              } else {
                this.dexieDBService.fullConstats.add(inventoryInProgress);
              }
              resolve();
            })
          },
          (error) => {
            this.snackBar.open('Une erreur est survenue pendant le chargement des données, certaines données n\'ont pas pu être chargées', 'Fermer', {duration: 3000})
            console.error(error);
            resolve()
          }
        );
      });
    });

    // Utilisation de Promise.all pour attendre que toutes les opérations asynchrones soient terminées
    return Promise.all(constatPromises);
  }

  getFileByConstatId(): Promise<void> {
    return this.dexieDBService.getAllDatasFromIndexDb('fullConstats').then((constats) => {
      if (!constats) return;

      const promises: Promise<void>[] = [];

      constats.forEach(constat => {
        const lignes = constat.lignes ?? constat?.EDLPrecedent?.lignes;

        if (lignes?.some((ligne: any) => ligne.photos)) {
          const promise = new Promise<void>((resolve) => {
            this.fileService.getFilesByConstatId(constat.id).subscribe(res => {
              res.then(zip => {
                const entryPromises: Promise<void>[] = [];

                zip.forEach((relativePath, zipEntry) => {
                  const entryPromise = zipEntry.async('arraybuffer').then((data) => {
                    const blob = new Blob([data], {type: 'image/jpeg'});
                    this.dexieDBService.oldFiles.add({previewUrl: blob, path: relativePath});
                  });

                  entryPromises.push(entryPromise);
                });

                Promise.all(entryPromises).then(() => resolve());
              });
            });
          });

          promises.push(promise);
        }
      });

      return Promise.all(promises).then(() => {
        console.log('All files added to IndexedDB ✅');
      });
    });
  }

}
